import { useEffect, useState } from "react";
import { marketingService } from "../services/api";

/**
 * Banners activos de una posición del admin (HOME_TOP, REGISTER…).
 * `loaded` permite no "parpadear" el banner fijo mientras llega la respuesta.
 */
export default function useBanners(position) {
  const [banners, setBanners] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    marketingService.getBanners(position).then((res) => {
      if (cancelled) return;
      setBanners(res.data || []);
      setLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, [position]);

  return { banners, loaded };
}
